import { PRESUPUESTADOR_CLEAR_BON_USADO } from './constants'

export function clearBonificacionUsado(patente) {
  return (dispatch, getState) => {
    const { presupuestador } = getState();
    const vehiculosUsados = presupuestador.entregaUsados;
    let modifiedVehiculosUsados = [...vehiculosUsados];

    const currentCarIndex = vehiculosUsados?.findIndex(item => item.patente === patente)
    const takeFinalPrice = vehiculosUsados[currentCarIndex].updatedTakePrice || vehiculosUsados[currentCarIndex].appraisal || vehiculosUsados[currentCarIndex].original_price
    modifiedVehiculosUsados[currentCarIndex] = { ...modifiedVehiculosUsados[currentCarIndex], final_take_price: takeFinalPrice, take_improvement_amount: 0 }
        dispatch({
          type: PRESUPUESTADOR_CLEAR_BON_USADO,
          data: modifiedVehiculosUsados
        })
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_CLEAR_BON_USADO) {
      return {
        ...state,
        entregaUsados: action.data
      }
  }
  else {
      return state
  }
}